import { Content } from 'antd/es/layout/layout'
import React,{ useState,
    useEffect
 } from 'react'
import { useDispatch } from 'react-redux';
// import { setOrganizationCreated } from '../../../store/Organization/organizationSlice';
import { ShowComingSoon } from '../../../functions/Utils'
import { ButtonSection, ContentRow, ContentTitle, ContentValue, DetailContentContainer } from '../../../StyledComponents/CreateKeyAccountManager'
import AddButton from '../Common/AddButton'
import SubmitButton from '../Common/SubmitButton'
import { setOrganizationCreated } from '../../../store/Organization/organizationSlice';
import {organizationlist} from '../../../store/Organization/organizationSlice'
function ProfileDetails(props) {
    const [orgdata, setOrgdata] = useState([])
    const [orgLoading, setOrgLoading] = useState(true)
    const dispatch = useDispatch();

    const handleCreateOrganization = () => {
        dispatch(setOrganizationCreated(true));
    };

    useEffect(() => {
        dispatch(organizationlist("all")).then(res => {
            setOrgdata(res?.payload?.data || [])
            setOrgLoading(false)
        }).catch(err => {
            console.error(err);
            setOrgLoading(false)
        })
    }, [])

    const pid = props?.instance?.org_data?._id
console.log(props?.instance?.org_data?._id,orgdata,"check34");
    let orgExists = false;
    if (pid) {
        for (let item of orgdata) {
            if (item._id == pid) {
                orgExists = true;
                break;
            }
        }
    }

    // show button only after org list has loaded AND org does not exist yet
    const showCreateButton = !orgLoading && !orgExists;
  return (
    <>
        <DetailContentContainer>
        <ContentRow>
            <ContentTitle>
                Full Name
            </ContentTitle>
            <ContentValue>
               {props.instance?.kyc_user?.full_name}
            </ContentValue>
        </ContentRow>
        <ContentRow>
            <ContentTitle>
                Organization Name
            </ContentTitle>
            <ContentValue>
               
               <div className='flex items-center'>
                    <div className={orgExists ? "text-green-600" : ""}>{props.instance?.company_name}</div>
                    {showCreateButton && (
                        <div className='flex justify-end items-center pt-2'>
                            <button
                                type="button"
                                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-xs px-4 py-1 me-2 mb-2 ml-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                                onClick={handleCreateOrganization}
                            >
                                Create Organization
                            </button>
                        </div>
                    )}
                </div>
            </ContentValue>
        </ContentRow>
        <ContentRow>
            <ContentTitle>
            Organization Type
            </ContentTitle>
            <ContentValue>
               {props.instance?.company_type}
            </ContentValue>
        </ContentRow>
       
        </DetailContentContainer>
        {/* <ButtonSection className='user-management'>
            <SubmitButton type='button' title="Send Reset Password Link" handleClick={()=> ShowComingSoon()} is_icon={false} ml="28px" />
        </ButtonSection> */}
    </>
    
  )
}

export default ProfileDetails
